const AUTH_TOKEN_KEY = 'authToken';
const AUTH_USER_FULL_NAME_KEY = 'authUserFullName';
const AUTH_PERMISSIONS_KEY = 'authPermissions';
const AUTH_ROLE_ID_KEY = 'authRoleId';

export function isAuthenticated() {
  return Boolean(localStorage.getItem(AUTH_TOKEN_KEY));
}

export function setAuthenticated(token) {
  if (!token) return;
  localStorage.setItem(AUTH_TOKEN_KEY, token);
}

export function setAuthUserFullName(fullName) {
  if (!fullName) return;
  localStorage.setItem(AUTH_USER_FULL_NAME_KEY, String(fullName));
}

export function getAuthUserFullName() {
  return localStorage.getItem(AUTH_USER_FULL_NAME_KEY) || '';
}

export function setAuthPermissions(permissions) {
  if (!Array.isArray(permissions)) return;
  localStorage.setItem(AUTH_PERMISSIONS_KEY, JSON.stringify(permissions));
}

export function getAuthPermissions() {
  const raw = localStorage.getItem(AUTH_PERMISSIONS_KEY);
  if (!raw) return [];
  try {
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function normalize(value) {
  return String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[_\s]+/g, '-');
}

function isMatch(item, target) {
  const targetKey = normalize(target);
  if (!targetKey) return false;
  return normalize(item?.slug) === targetKey || normalize(item?.name) === targetKey;
}

export function hasPermission(target) {
  const permissions = getAuthPermissions();
  if (!Array.isArray(permissions) || permissions.length === 0) return false;
  return permissions.some((item) => isMatch(item, target));
}

export function hasSubPermission(parentTarget, subTarget) {
  const permissions = getAuthPermissions();
  if (!Array.isArray(permissions) || permissions.length === 0) return false;
  const parent = permissions.find((item) => isMatch(item, parentTarget));
  if (!parent) return false;
  const subList = Array.isArray(parent?.subPermissions) ? parent.subPermissions : [];
  return subList.some((item) => isMatch(item, subTarget));
}

export function setAuthRoleId(roleId) {
  if (roleId == null || Number.isNaN(Number(roleId))) return;
  localStorage.setItem(AUTH_ROLE_ID_KEY, String(Number(roleId)));
}

export function getAuthRoleId() {
  const raw = localStorage.getItem(AUTH_ROLE_ID_KEY);
  if (!raw) return null;
  const parsed = Number(raw);
  return Number.isNaN(parsed) ? null : parsed;
}

export function getAuthToken() {
  return localStorage.getItem(AUTH_TOKEN_KEY);
}

export function clearAuthentication() {
  localStorage.removeItem(AUTH_TOKEN_KEY);
  localStorage.removeItem(AUTH_USER_FULL_NAME_KEY);
  localStorage.removeItem(AUTH_PERMISSIONS_KEY);
  localStorage.removeItem(AUTH_ROLE_ID_KEY);
}
